import { useContext } from 'react';
import { AuthContext } from '@/lib/contexts/auth.jsx';
import { useSelector } from 'react-redux';

const useLoadUser = () => {
  const { isLoaded, isLoggedIn, isEmbeddedEndUser } = useContext(AuthContext);
  const user = useSelector((state) => state?.user?.jwt);
  const hasCompanies = useSelector((state) => state?.user?.companies?.length > 0);

  if (isEmbeddedEndUser) {
    return { isLoaded: true, isLoggedIn: true, isEmbeddedEndUser: true };
  }

  if (!isLoggedIn && isLoaded) {
    return { isLoaded, isLoggedIn, isEmbeddedEndUser: false };
  }

  if (!user?.companyId || !user?.permissions || !user?.roleId || !hasCompanies) {
    return { isLoaded: false, isLoggedIn, isEmbeddedEndUser: false };
  }

  return { isLoaded, isLoggedIn, isEmbeddedEndUser: false };
};

export default useLoadUser;
